<template>
  <section class="d-flex flex-column h-full">
    <div class="mdc-top-app-bar__row shadow">
      <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start t-color-red3">
        <a
          class="material-icons blue0006 mdc-top-app-bar__navigation-icon"
          @click="$router.go(-1)"
        >arrow_back</a>
      </section>

      <section class="mdc-top-app-bar__section title">
        <div class="mdc-top-app-bar__title">{{ $t('1730') }}</div>
      </section>

      <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end t-color-red3">
        <a class="material-icons blue0006 mdc-top-app-bar__navigation-icon"></a>
      </section>
    </div>
    <div id="tab1" class="t-color-gray2">
      <div
        class="t-color-title t-headline7 l-spacing6 pdl-16 pdr-16 pdt-16 pdb-4 t-center font-r"
      >{{ $t('1731') }}</div>
      <div
        class="t-color-content1 t-body3 l-spacing6 pdl-16 pdr-16 pdt-4 pdb-8 t-center font-r"
      >{{ $t('1732', {str: '8.0.1'}) }}</div>
      <div class="fixed-bottom pdl-8 pdr-8">
        <a
          href="#"
          class="t-center d-block bg-dark pdt-11 pdb-11 pdl-16 t-color-white b-radius4 mgb-32 b-shadow2 t-body2 shadow-bottom l-spacing42"
        >{{ $t('1735') }}</a>
      </div>
    </div>
  </section>
</template>

<style scoped>
.shadow {
  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}
</style>

<script>
export default {};
</script>